module.exports = __webpack_public_path__ + "static/media/boots.41290240.jpg";